<template>
  <div class="min-h-screen flex flex-col bg-gray-50">
    <template v-if="effectiveLayout === 'public'">
      <AppHeader />
      <main class="flex-1 min-h-0">
        <router-view />
      </main>
      <AppFooter />
    </template>

    <template v-else-if="effectiveLayout === 'minimal'">
      <main class="flex-1 min-h-0">
        <router-view />
      </main>
    </template>

    <template v-else-if="effectiveLayout === 'tenant-dashboard'">
      <router-view />
    </template>

    <template v-else-if="effectiveLayout === 'admin'">
      <AdminLayout class="flex min-h-dvh flex-1 flex-col min-w-0">
        <router-view />
      </AdminLayout>
    </template>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue';
import AppHeader from './components/layout/AppHeader.vue';
import AppFooter from './components/layout/AppFooter.vue';
import { useEffectiveLayout } from './composables/useEffectiveLayout';
import { useDocumentTitle } from './composables/useDocumentTitle.js';

const AdminLayout = defineAsyncComponent(() => import('./components/layout/AdminLayout.vue'));

const effectiveLayout = useEffectiveLayout();
useDocumentTitle();
</script>

<style>
#app {
  font-family: system-ui, -apple-system, sans-serif;
}
</style>
